import styled from "@emotion/styled";
import BigText from 'components/ui/BigText';
import ContextContainer from 'components/ui/ContextContainer';
import { usePutUserData } from "hooks/api";
import { useDaumPostcodePopup } from 'react-daum-postcode';
import { IoIosArrowBack } from 'react-icons/io';
import { Button, Toast } from 'components/ui';
import { useGetUserInfo } from 'hooks/api';
import { useEffect, useState } from 'react';

const Elem:React.FC<any> = () => {
  const [ infoData, setInfoData ] = useState({
    name:"",
    mobile : "",
    postalNumber: "",
    defaultAddress : "",
    detailAddress: "",
  });
  const data = useGetUserInfo();
  const { refetch:gerUserInfo } = useGetUserInfo();
  const userData = data.data?.userInfoParam;
  const { mutateAsync: putUserData }     = usePutUserData();
  const [ isToastOpen, setIsToastOpen ]  = useState<boolean>(false);
  const [ toastMessage, settoastMessage ]   = useState<string>("");
  
  const handleGoToHome = () => {
    window.location.href="/home"
  };

  const handleComplete = (data:any) => {
    setInfoData(prevInfoData => ({
      ...prevInfoData,
      postalNumber: data?.zonecode,
      defaultAddress: data?.address
    }))
  };

  const handleInfoData = () => {
    setInfoData({
      name: userData?.name,
      mobile:userData?.mobile,
      postalNumber: userData?.postalNumber,
      defaultAddress : userData?.defaultAddress,
      detailAddress: userData?.detailAddress,
    })
  };

  const handleNameChange = (event:any) => {
    setInfoData(prevInfoData => ({
      ...prevInfoData,
      name : event.target.value
    }));
  };

  const handleMobileChange = async (event:any) => {
    setInfoData(prevInfoData => ({
      ...prevInfoData,
      mobile : event.target.value
    }));
  };

  const handleDetailAddressChange = async (event:any) => {
    setInfoData(prevInfoData => ({
      ...prevInfoData,
      detailAddress : event.target.value
    }));
  };

  const handlePostCodeClick = async () => {
    await open({ onComplete: handleComplete })
  };

  const handleSendingAddressData = async () => {
    await putUserData(infoData); 
    gerUserInfo();
    setIsToastOpen(true);
    settoastMessage("업데이트가 완료 되었습니다!");
  };

  const handleCloasToast = () => {
    setIsToastOpen(false);
  };

  useEffect(() => {
    handleInfoData()
  }, [userData])

  const scriptUrl = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
  const open = useDaumPostcodePopup(scriptUrl);
  
  return (
      <Container>
        <ContextContainer className="Title">
          <InfoBigText>기본정보</InfoBigText>
          <LoginTypeInfo>카카오 계정</LoginTypeInfo>
        </ContextContainer>
        <FirstBox>
          <SubTitle>이름</SubTitle>
          <ContextContainer className="contextFirst">
            <InputStyle 
              type="textarea"
              onChange={handleNameChange}
              value= {infoData?.name || ""}
              />
          </ContextContainer>
          <SubTitle>휴대폰 번호</SubTitle>
          <ContextContainer className="context">
            <InputStyle 
              type="textarea"
              onChange={handleMobileChange}
              value= {infoData?.mobile || ""}
              />
          </ContextContainer>
        </FirstBox>
        <ContextContainer>
          <InfoBigText>배송지 정보</InfoBigText>
        </ContextContainer>
        <SecondBox>
          <SubTitle>배송지</SubTitle>
          <ContextContainer className="Title">
            <ContextContainer className="small">
              {infoData?.postalNumber || ""}
            </ContextContainer>
            <ButtonWrapper>
              <ModifyButton 
                layoutVariant='contained'
                variant='default'
                size='large'
                expand
                onClick={handlePostCodeClick}
              > 
                수정
              </ModifyButton>
            </ButtonWrapper>
          </ContextContainer>
          <ContextContainer className='context'>
            {infoData?.defaultAddress || ""} 
          </ContextContainer>
          <ContextContainer className='context'>
            <InputStyle 
              type="textarea"
              onChange={handleDetailAddressChange}
              value= {infoData?.detailAddress || ""}
              />
          </ContextContainer>
        </SecondBox>
        <SendingButtonWrapper>
          <ToastContainer>
            {isToastOpen && 
              <Toast 
                message={toastMessage}
                onClose={handleCloasToast}
              />}
          </ToastContainer>
            <SubmitButton
              layoutVariant="contained"
              variant="default"
              expand
              isActive={
                !!(infoData.name 
                  && infoData.mobile
                  && infoData.postalNumber
                  && infoData.defaultAddress
                  && infoData.detailAddress
                )
              }
              onClick={handleSendingAddressData}
            >
              변경 사항 저장
            </SubmitButton>
          </SendingButtonWrapper>
      </Container>
  );
};

export default Elem;

const Container = styled.div`
  width: 430px;
  height: 100%;
  min-height: 0vh;

  display: flex;
  flex-direction: column;
`
const InfoBigText = styled(BigText)`
  font-size: 23px;
  font-weight: 700;
  margin-top: 16px;
`
const LoginTypeInfo = styled.div`
  width: 80px;
  height: 100%;
  padding-top: 16px;


  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  text-align: right;
  color: var(--light-grey);
`

const FirstBox = styled.div`
  width: 100%;
  height: 201px;

  margin-top: 21px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
`

const SubTitle = styled.div`
  height: 26px;

  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
  color: var(---black);
  margin-bottom: 6px;
`
const SecondBox = styled.div`
  height: 230px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
const ButtonWrapper = styled.div`
  width: 147px;
  height: 100%;
`;

const ModifyButton =styled(Button)`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
`;
const InputStyle = styled.input`
  background-color: var(--light-grey);
  color: #636363;
`;
const SendingButtonWrapper = styled.div`
  width: 299px;
  height: 52px;
  margin: 63px auto 0px;
`;
interface ButtonProps {
  isActive:boolean;
}
const SubmitButton = styled(Button)<ButtonProps>`
  border: 2px solid ${({ isActive }) => (isActive? 'rgba(20, 20, 20, 1)' : `rgba(177, 177, 177, 1)`)};
  color :${({ isActive }) => (isActive? 'rgba(20, 20, 20, 1)' : `rgba(177, 177, 177, 1)`)};
  cursor: ${({ isActive }) => (isActive ? 'pointer' : 'not-allowed')};
`;
const ToastContainer = styled.div`
  width: 200px;
  height: 43px;
  margin: 0 auto 10px;
  position: relative;
`;